// 🎯 POG Lingo — the official kool phrases. Shared by the Post-a-POG composer
// and the browsable /lingo page.
export const POG_LINGO = [
  "POG ME = FRIEND ME 🤝",
  "POG ME BACK = ACCEPT THE POG 🤝",
  "POG'ALONG = FOLLOW ME 🎈",
  "POGLICIOUS = ❤️ LIKE IT",
  "POG IT = POST IT · SHARE IT · GRAB IT",
  "POG'OGRAM = SEND A POG 💌",
  "Just POG it.",
  "POGNOMENAL!",
  "You on the POG STRIP yet? 🔥",
  "POG a deal on the POG STRIP & get LIT 🔥",
  "My STRIP CHIP is glowing 🔥",
  "Light up the Strip!",
  "You've been POG'd!",
  "POG away!",
  "A POG'n good time",
  "POG the way you feel",
  "POG'd it!",
  "POG is heating up 🔥",
  "POGZILLA approved 🦖",
  "Catch it before it's POG'd",
  "POG'rs welcome",
  "Kool POG vibes",
  "POG o'clock",
  "Get your POG on",
  "Don't blink — just POG",
  "POG it all!",
  "Big POG energy",
  "This POG's for you. 🍻",
  "Follow the POG",
  "Gotta POG 'em all",
  "Same vision — just POG it",
  "In POG we trust 🇺🇸",
  "May the POG be with you.",
];
